import { Briefcase, StickyNote } from '../../icons';
import InteractiveCard from '../../common/interactiveCard';
import FavouriteStatus from '../../favouriteStatus/favouriteStatus';
import CardData from '../cardData';
import { IMatter } from '../../../interface/matter';
import { getMatterIconClass, getMatterLabel } from '../../../constants/utilityFunctions';
import { useTranslation } from 'react-i18next';
import { InvoiceableType, MatterStatus } from '../../../constants/matter';
import { useTransaction } from '../../../context/TransactionContext';
import { Divider } from '../../Ant';
import { BorderColor, TagColor } from '../../../interface/common';

const MatterCard = ({
  matter,
  onClick,
  selectedMatter,
}: {
  matter: IMatter;
  onClick: (matter: IMatter) => void;
  selectedMatter?: IMatter;
}) => {
  const { t } = useTranslation();
  const { transaction } = useTransaction();

  return (
    <InteractiveCard
      data-testid="matter-card-button"
      className={`w-full pointer ${
        matter?.status === MatterStatus.ACTIVE ? BorderColor.GREEN : BorderColor.RED
      }  ${transaction?.matter?.id === matter.id || selectedMatter?.id === matter.id ? 'transaction-active-card' : ''}`}
      onActivate={() => {
        onClick(matter);
      }}
    >
      <div className="d-flex justify-between pb-10 items-center">
        <div className="d-flex gap-5 items-center">
          <div
            data-testid="invoiceable-type-id"
            className={`status-chip d-flex justify-center items-center ${matter?.status === MatterStatus.ACTIVE ? TagColor.GREEN : TagColor.RED}`}
          >
            {matter?.invoiceableType &&
              t(
                `matter:invoiceableType.${Object.keys(InvoiceableType).find((key) => InvoiceableType[key as keyof typeof InvoiceableType] === matter?.invoiceableType) ?? matter?.invoiceableType}`,
              )}
          </div>
          {matter?.hasImportantNotes && <StickyNote className="sticky-note-icon" />}
        </div>
        <FavouriteStatus isFavourite={matter?.isFavorite} testId="favourite-button" />
      </div>
      <Divider className=" mb-10" />
      <CardData
        type="matter"
        icon={<Briefcase className={getMatterIconClass(matter?.invoiceableType ?? '')} />}
        title={getMatterLabel(t, matter?.invoiceableType)}
        content={
          matter?.principalCompany?.name
            ? matter?.principalCompany?.name
            : (matter?.principalPrivatePerson?.fullName ?? '')
        }
        subcontent={matter?.matterNumber + ' - ' + matter?.subject}
        contentclass="lineclamp-1"
        subcontentclass="lineclamp-1"
      />
    </InteractiveCard>
  );
};

export default MatterCard;
